import videojs from 'video.js';

const TextTrackDisplay = videojs.getComponent('TextTrackDisplay');

class CustomTextTrackDisplay extends TextTrackDisplay {
  preselectTrack() {
    super.preselectTrack();

    // snapshot by contrib-ads is not updated when preselectTrack is called,
    // and cause subtitiles are all set to disabled after adbreak
    // https://github.dev/videojs/videojs-contrib-ads/blob/8aec8c7a8c82c65f3c586cdaa8ce14cef7f7c569/src/snapshot.js#L47-L57
    if (this.player_?.ads?.snapshot?.suppressedTracks) {
      const tracks = this.player_.textTracks?.() || [];
      const newSuppressedTracks = [];

      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];

        newSuppressedTracks.push({
          track,
          mode: track.mode,
        });
      }

      this.player_.ads.snapshot.suppressedTracks = newSuppressedTracks;
    }
  }
}

// override video.js original TextTrackDisplay
videojs.registerComponent('TextTrackDisplay', CustomTextTrackDisplay);

export default CustomTextTrackDisplay;
